import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectQueryParams } from '../../selectors/page';
import { ValuationBannerComponent, ValuationModalComponent } from '../../components/ValuationBanner';
import { ModalWindow } from '@cian/ui-kit';
import { checkIsUserFromMainPage } from '../../utils/isUserFromMainPage';
import { useIsDesktop } from '@cian/valuation-utils-component';

export const ValuationBanner: React.FC = () => {
  const isDesktop = useIsDesktop();
  const [isModalOpen, setModalOpen] = React.useState<boolean>(false);

  const queryParams = useSelector(selectQueryParams);
  const isUserFromMainPage = checkIsUserFromMainPage(queryParams?.from);

  const handleModalOpen = React.useCallback(() => {
    setModalOpen(true);
  }, [isModalOpen, setModalOpen]);

  const handleModalClose = React.useCallback(() => {
    setModalOpen(false);
  }, [isModalOpen, setModalOpen]);

  if (!isUserFromMainPage) {
    return null;
  }

  return (
    <>
      <ValuationBannerComponent isDesktop={isDesktop} onClick={handleModalOpen} />

      <ModalWindow
        maxWidth={500}
        open={isModalOpen}
        onClose={handleModalClose}
        content={<ValuationModalComponent isDesktop={isDesktop} onCLick={handleModalClose} />}
      />
    </>
  );
};
